import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Card } from '../../../components/Card';
import { HBox, VBox } from '../../../components/Box';
import { Button } from '../../../components/Buttons';
import { ChangeLocationModal } from './ChangeLocationModal';
import { setVehicleLocation, setVehicleProperty, updateSelectedVehicles } from '../actions';
import { Loader } from '../../../components/Loader';
import { selectWorks } from '../../Api/selectors';
import { REQUEST_VEHICLE_PROPERTY_UPDATE } from '../constants';
import { WithVehicle } from './WithVehicle';
import { FormField } from '../../../components/FormFields';
import { InputWithInitialValue } from './InputWithInitialValue';
import { selectVehicle } from '../selectors';
import _ from 'lodash';
import { ButtonBar } from '../../../components/ButtonBar';
import { VehiclePropertyLoadable } from './VehiclePropertyLoadable';
import { Dropdown } from '../../../components/Dropdown';
import { CompanyLabelById } from '../../Companies/components/CompanyLabelById';
import { CompanySelectionModalButton } from '../../Companies/components/CompanySelectionModalButton';
import styles from './VehiclePropertyEditableInput.module.css';

const STATE = {};

export const DROPDOWN_OPTIONS = {
  sales_preferred_vehicle: [0, 1, 2, 3, 4, 5, 6]
    //convert to string
    .map(n => n + ''),
};

/* eslint-disable react/prefer-stateless-function */
class VehiclePropertyEditableInputComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
      value: props.value || '',
    });
  }

  componentDidMount() {}

  propertyValue(name) {
    return this.props.vehicle?.[name || this.props.propertyName];
  }

  render() {
    //  if (this.props.loading) return <Loader small />;

    if (this.props.vehicleIds?.length) {
      return <VehiclePropertyLoadable name={this.props.propertyName}>{this.renderBody()}</VehiclePropertyLoadable>;
    }

    return (
      <WithVehicle vehicle_id={this.props.vehicle_id}>
        <VehiclePropertyLoadable name={this.props.propertyName}>{this.renderBody()}</VehiclePropertyLoadable>
      </WithVehicle>
    );
  }

  renderDropdown(options) {
    if (!options)
      options = DROPDOWN_OPTIONS[this.props.propertyName].map(value => ({
        label: this.lbl(`vehicle.property.${this.props.propertyName}.${value}`),
        value,
      }));

    return (
      <InputWithInitialValue
        label={this.lbl(`vehicle.property.${this.props.propertyName}`)}
        onChange={this.props.update}
        dropdown
        value={this.propertyValue()}
        options={options}
      />
    );
  }

  renderBody() {
    if (!this.props.vehicle && !this.props.vehicleIds?.length) return null;

    if (this[`render_${this.props.propertyName}`]) return this[`render_${this.props.propertyName}`]();
    if (this.props.propertyName in DROPDOWN_OPTIONS) return this.renderDropdown();
    const value = this.props.vehicle ? this.props.vehicle[this.props.propertyName] : '';
    return (
      <InputWithInitialValue
        className={this.props.className}
        classNameInput={this.props.classNameInput}
        label={this.lbl(`vehicle.property.${this.props.propertyName}`)}
        value={value}
        onChange={this.props.update}
      />
    );
  }

  render_num_keys() {
    return (
      <VBox className="num_keys">
        <div>{this.lbl(`vehicle.property.num_keys`)}</div>
        <div className={styles.containerButtonBar}>
          <ButtonBar>
            {_.times(6, num => {
              num += 0;
              return (
                <Button
                  className={styles.buttonBarItem}
                  key={num}
                  small
                  disabled={this.props.work}
                  primary={num == this.propertyValue()}
                  onClick={() => {
                    this.props.update?.(num);
                  }}
                >
                  {num}
                </Button>
              );
            })}
          </ButtonBar>
        </div>
      </VBox>
    );
  }

  render_transport_planned_incoming() {
    return (
      <VBox className="num_keys">
        <div>{this.lbl(`vehicle.property.transport_planned_incoming`)}</div>
        <ButtonBar>
          {_.times(2, num => {
            num += 0;
            return (
              <Button
                key={num}
                small
                disabled={this.props.work}
                primary={num == this.propertyValue()}
                onClick={() => {
                  this.props.update?.(num);
                }}
              >
                {num === 0 ? 'nee' : 'ja'}
              </Button>
            );
          })}
        </ButtonBar>
      </VBox>
    );
  }

  render_transport_planned_outgoing() {
    return (
      <VBox className="num_keys">
        <div>{this.lbl(`vehicle.property.transport_planned_outgoing`)}</div>
        <ButtonBar>
          {_.times(2, num => {
            num += 0;
            return (
              <Button
                key={num}
                small
                disabled={this.props.work}
                primary={num == this.propertyValue()}
                onClick={() => {
                  this.props.update?.(num);
                }}
              >
                {num === 0 ? 'nee' : 'ja'}
              </Button>
            );
          })}
        </ButtonBar>
      </VBox>
    );
  }

  render_vehicle_purpose() {
    return this.renderDropdown(
      ['passenger', 'commercial'].map(name => ({
        label: this.lbl(`vehicle.property.vehicle_purpose.${name}`),
        value: name,
      })),
    );
  }

  render_tax_type() {
    return this.renderDropdown(
      ['BTW', 'marge'].map(name => ({
        label: this.lbl(`vehicle.property.vehicle_purpose.${name}`),
        value: name,
      })),
    );
  }

  render_creditor_company() {
    return (
      <>
        <HBox vCenter>
          <CompanyLabelById company_id={this.propertyValue()} />
          <CompanySelectionModalButton onChange={this.props.update} />
        </HBox>
      </>
    );
  }
}

VehiclePropertyEditableInputComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    vehicle: selectVehicle(ownProps.vehicle_id),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    update(value) {
      if (ownProps.vehicleIds) {
        const propertiesArr = [{ propertyName: ownProps.propertyName, propertyValue: value }];
        dispatch(updateSelectedVehicles(ownProps.vehicleIds, propertiesArr, ownProps.updateCallback));
      } else {
        dispatch(setVehicleProperty(ownProps.vehicle_id, ownProps.propertyName, value));
      }
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehiclePropertyEditableInput = compose(withConnect, withRouter)(VehiclePropertyEditableInputComp);
